<p-dialog [visible]="openDialogExport" [style]="{ height: '80vh', width: '50vw', minWidth: '50vw', maxWidth: '50vw' }"
  [header]="'Export'" class="modal-actions" (visibleChange)="closeDialog()">

  <div class="header-item" data-bs-auto-close="outside">
    <div class="d-flex align-items-center">
      <img class="me-2" [src]="imgPath" style="width: 40px; height: 40px" />
      <div class class="ms-3">
        <span class="header-item-info-bold">
          {{
          exportItems?.lastExport?.exportDateTime
          ? "Date du dernier export : " + (exportItems?.lastExport?.exportDateTime | date: 'dd/MM/yyyy à HH:mm')
          : "Pas encore d'export"
          }}
        </span>
        <div class="header-item-info">
          {{ exportItems?.lastExport?.userId ? exportItems?.lastExport?.userName : '' }}
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <p-tag styleClass="ms-3 me-3" *ngIf="exportItems?.lastExport?.statutId"
        [severity]="getSeverity(exportItems?.lastExport?.statutId)"
        [value]="statusExport | label_by_id: exportItems?.lastExport?.statutId | translate" [rounded]="true"></p-tag>
    </div>
  </div>

  <!-- BODY CONTENT -->
  <super-tabs class="d-flex justify-content-center mb-3" [items]="tabs" (slug)="tabChange($event)"></super-tabs>
  <!-- EXPORT -->
  <ng-container *ngIf="activeTab === 0 && typeExport === 'mandataire'">
    <div class="body">
      <section [formGroup]="formExportMandataire" class="mt-3 flex-grow-1">
        <div class="row mt-2 mb-2 tac-filter-alert text-center p-2 my-3 mx-3">
          <div class="col-12">
            <div>
              <i class="fas fa-exclamation-triangle orange-icon"></i> Rappel : N'oubliez pas de donner aux mandataires
              l'accès à cette séance sur Délibé Web
            </div>
            <div class="mt-1"><a href="https://edelibe.myinforius.be">https://edelibe.myinforius.be</a></div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-2 mb-1">
            <label class="super-compos-label-input">Commentaire associé à ce nouvel export</label>
            <textarea class="w-100" pInputTextarea formControlName="commentaires" rows="5"></textarea>
          </div>
        </div>
      </section>
      <footer class="mt-auto">
        <div class="d-flex align-items-center justify-content-end">
          <div class="d-flex">
            <super-button styleClass="green me-2" (click)="exportMandataireNow()" text="Exporter"></super-button>
          </div>
        </div>
      </footer>
    </div>
  </ng-container>
  <ng-container *ngIf="activeTab === 0 && typeExport === 'citoyen'">
    <div class="body">
      <section class="mt-3 flex-grow-1">
        <div class="row mt-2 mb-2 tac-filter-alert d-flex justify-content-center p-2 my-3 mx-3">
          <a href="https://conseilcommunal.be/">https://conseilcommunal.be/</a>
        </div>
      </section>
      <section>
        <i-table-v17 *ngIf="activeTab === 0 && typeExport === 'citoyen'" [id]="'export-citoyen-point'"
          [config]="tableConfigurations" [items]="listOfPointsCitoyenExportFiltered"
          [columns]="columnsExportCitoyenPoints" [customActionManualReset]="true">
        </i-table-v17>
      </section>
      <footer class="mt-3">
        <div class="d-flex align-items-center justify-content-end">
          <div class="d-flex">
            <super-button styleClass="green me-2" (click)="exportCitoyenNow()" text="Exporter"></super-button>
          </div>
        </div>
      </footer>
    </div>
  </ng-container>

  <!-- HISTORIC -->
  <ng-container *ngIf="activeTab === 1  && typeExport === 'mandataire'">
    <i-table-v17 [config]="tableConfigurations" [items]="exportItemsHistoricMandataire"
      [columns]="columnsHistoricExportDelibeMandataire" [id]="'i-table-historic-export-delibe-mandataire'"></i-table-v17>
  </ng-container>
  <ng-container *ngIf="activeTab === 1  && typeExport === 'citoyen'">
    <i-table-v17 [config]="tableConfigurations" [items]="exportItemsHistoricCitoyen"
      [columns]="columnsHistoricExportDelibeMandataire" [id]="'i-table-historic-export-delibe-citoyen'"></i-table-v17>
  </ng-container>
</p-dialog>